export const GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_ABORTED =
  'GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_ABORTED';
export const GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_REQUESTED =
  'GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_REQUESTED';
export const GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_COMPLETED =
  'GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_COMPLETED';
export const GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_FAILED =
  'GET_CLIENTWITHDRAWALS_FOR_ACCOUNT_FAILED';
